import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { FieldValuesResponse } from '../../Model/responseDtos/FieldValuesResponse';
import { LoadFieldValuesFromFileRequest } from '../../Model/requests/LoadFieldValuesFromFileRequest';
import { mutateFieldsKeys } from './mutateKeyFactory';
import { useContext } from 'react';
import ServicesContext from '../../global/services/ServicesContext';

export function useLoadFieldValuesFromFile(): UseMutationResult<
  FieldValuesResponse,
  unknown,
  LoadFieldValuesFromFileRequest,
  unknown
> {
  const servicesCtx = useContext(ServicesContext);

  const loadFieldValues = (request: LoadFieldValuesFromFileRequest) => {
    if (servicesCtx?.fieldsService) {
      return servicesCtx.fieldsService.loadFieldValuesFromFile(request);
    }
    throw new Error('Services context not initialized');
  };

  return useMutation({
    mutationKey: mutateFieldsKeys.loadFieldValuesFromFile,
    mutationFn: (request: LoadFieldValuesFromFileRequest) => loadFieldValues(request)
  });
}
